import UserOld from './index';

export default { path: '/home/userOld', component: UserOld };
